<template>
  <Content nav="true" admin="true">
    <h1>Events</h1>
    <table class="pure-table pure-table-horizontal crud">
      <thead>
        <tr>
          <th>Date</th>
          <th>Name</th>
          <th>Location</th>
          <th>
            <form class="pure-form">
              <input
                v-model="searchQuery"
                type="search"
                class="pure-input-rounded"
                placeholder="Search"
              >
              &nbsp;
              <button
                @click.prevent="add"
                class="pure-button button-xsmall button-success"
              >
                <font-awesome-icon icon="plus"/>
              </button>
            </form>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="event in searchResults" :key="event.id">
          <td>{{ event.data().date | moment }}</td>
          <td>{{ event.data().name }}</td>
          <td>{{ event.data().location }}</td>
          <td>
            <div class="pure-button-group">
              <button
                @click.prevent="edit(event.id)"
                class="pure-button button-xsmall button-secondary"
              >
                <font-awesome-icon icon="edit"/>
              </button>
              <button @click.prevent="remove(event)" class="pure-button button-xsmall button-error">
                <font-awesome-icon icon="trash-alt"/>
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </Content>
</template>

<script>
import Session from '@/mixins/Session.js'
import Moment from 'moment'

export default {
  name: 'Events',
  mixins: [Session],
  beforeMount() {
    this.authorize()
  },
  data() {
    return {
      ref: this.$database.collection('events'),
      searchQuery: '',
      events: []
    }
  },
  filters: {
    moment: function(date) {
      return Moment(date).format('MMMM D, YYYY @ h:mma')
    }
  },
  computed: {
    searchResults() {
      if (this.searchQuery === '') {
        return this.events
      } else {
        return this.events.filter(event =>
          event
            .data()
            .name.toLowerCase()
            .includes(this.searchQuery.toLowerCase())
        )
      }
    }
  },
  methods: {
    get() {
      this.ref
        .orderBy('date', 'desc')
        .get()
        .then(collection => (this.events = collection.docs))
    },
    add() {
      this.ref
        .add({
          date: null,
          description: '',
          location: '',
          name: ''
        })
        .then(doc => this.edit(doc.id))
    },
    edit(id) {
      this.$router.push({ name: 'event', params: { id: id } })
    },
    remove(event) {
      if (confirm(`Remove event ${event.data().name}?`)) {
        this.ref.doc(event.id).delete()
        this.get()
      }
    }
  },
  mounted() {
    this.get()
  }
}
</script>
